/**
 * @file Automatically generated by barrelsby.
 */

export * from './paginator.component';
export * from './paginator.service';
